module.exports = __webpack_public_path__ + "img/building-2.8608ea3d.svg";